import { chatScroll } from '../helpers/chat-scroll';

export let chat = () => {
  const webinarContainer = document.querySelector('.webinar-container');

  if (webinarContainer) {
    const pageContainer = webinarContainer.parentElement;
    const showChatButton = document.getElementById('show-chat');

    showChatButton.addEventListener('click', function () {
      toggleChat(webinarContainer, pageContainer);
      chatScroll();
    });

    const hideChatButton = document.getElementById('hide-chat');
    hideChatButton.addEventListener('click', function () {
      toggleChat(webinarContainer, pageContainer);
    });

    triggerClickOnHideButton(webinarContainer, pageContainer);
    webinarChatScroll();
  }
};

let triggerClickOnHideButton = (webinar, page) => {
  const hideChatButton = document.getElementById('hide-chat');
  hideChatButton.addEventListener('keydown', function(e) {
    if (e.key === " ") { e.preventDefault(); }
    if (e.key === 'Enter' || e.key === " ") { toggleChat(webinar, page) }
  });
};

let toggleChat = (webinar, page) => {
  webinar.classList.toggle('show-chat');
  page.classList.toggle('show-chat');
  $('button#show-chat .badge').remove();
  $('button#show-chat').data().count = 0;
};

let webinarChatScroll = () => {
  const chatContainer = document.getElementById('chat');
  if (chatContainer) {
    const submitButton = $('.chat-scroll');
    submitButton.on('click', chatScroll);
  }
};
